import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, SearchResultFlat } from '@agissc/ktag-map';
import SearchResultItem from './SearchResultItem';
import FavoriteButton from '../button/FavoriteButton';
import { markedLabel } from '../../utils/StringHelper';

interface SearchLocationProps {
  location: SearchResultFlat;
  markedText: string;
  isSelected: boolean;
  isFavorite: boolean;
  onClick: () => void;
  onToggleFavorite: () => void;
  onIconClick: () => void;
}

const SearchLocation = ({
  location,
  markedText,
  isSelected,
  isFavorite,
  onClick,
  onToggleFavorite,
  onIconClick,
}: SearchLocationProps) => {
  const { t } = useTranslation('agisviewer');
  return (
    <SearchResultItem
      key={location.id}
      label={markedLabel(location.label, markedText)}
      resultType={t(location.origin)}
      isSelected={isSelected}
      onClick={onClick}
    >
      {isSelected && (
        <IconButton
          icon="map-marker"
          title={t('search_results_subtitle_location')}
          onClick={onIconClick}
          additionalClassNames="result-item__button-icon"
        />
      )}
      <FavoriteButton
        isFavorite={isFavorite}
        onClick={onToggleFavorite}
        title={isFavorite ? t('favorite_remove') : t('favorite_add')}
      />
    </SearchResultItem>
  );
};

export default SearchLocation;
